import * as React from "react";
const SvgHelp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#111927" clipPath="url(#demo_svg__a)">
      <path d="M24 11.269v1.498c-.013.06-.034.12-.039.18-.21 2.626-1.174 4.942-2.905 6.925-1.862 2.132-4.198 3.45-6.991 3.946-.436.078-.878.122-1.317.182h-1.501c-.068-.014-.135-.03-.204-.04-.714-.122-1.443-.188-2.14-.373-5.779-1.53-9.51-7.023-8.822-12.975.32-2.754 1.452-5.146 3.444-7.068C6.82.366 10.771-.74 15.175.493c4.774 1.337 7.634 4.602 8.64 9.46.09.432.125.877.185 1.316m-22.13.737c-.01 5.575 4.51 10.102 10.105 10.122 5.59.02 10.14-4.508 10.15-10.1.01-5.577-4.508-10.102-10.105-10.12-5.59-.02-10.14 4.507-10.15 10.098z" />
      <path d="M11.06 14.015c0-.975-.002-1.949 0-2.924 0-.598.402-1.033.946-1.025.54.006.928.43.928 1.02v5.87c0 .593-.388 1.007-.934 1.009-.548 0-.94-.415-.94-1.004-.003-.982 0-1.964 0-2.946M12.003 6.397c.701.003 1.262.567 1.258 1.266a1.272 1.272 0 0 1-1.272 1.26A1.274 1.274 0 0 1 10.73 7.65a1.26 1.26 0 0 1 1.272-1.253z" />
    </g>
    <defs>
      <clipPath id="demo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHelp;